/* Imports */
import React from "react"
import { Hr } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

const HrPage = () => {
    const items = [
        {
            content: <Hr />,
            code: "<Hr />",
        },
    ]

    return <ComponentPage items={items} />
}

export default HrPage
